import React from 'react';
import { Container } from '@material-ui/core';
import { makeStyles, createStyles, type Theme } from '@material-ui/core/styles';
import { useTranslate } from '@sprinx/react-globalize';
import { projectName } from '../../../config';

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        flexWrap: 'wrap',
      },
      advantage: {
        display: 'flex',
        flexDirection: 'row',
        padding: theme.spacing(2),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
          width: '50%',
        },
        [theme.breakpoints.up('md')]: {
          width: '25%',
        },
      },
      icon: {
        width: 32,
        height: 32,
        marginRight: theme.spacing(2),
      },
      text: {
        flex: 1,
      },
      label: {
        fontWeight: 'bold',
        fontSize: '1rem',
        marginBottom: theme.spacing(0.5),
      },
    }),
  { name: 'Advantages' },
);

const advantageItems = [
  { key: 'freeShipping', src: `/${projectName}/icons/distribution_icon.svg` },
  { key: 'productsInStock', src: `/${projectName}/icons/free_delivery_icon.svg` },
  { key: 'officialDistribution', src: `/${projectName}/icons/products_on_stock_icon.svg` },
  { key: 'professionalsOnly', src: `/${projectName}/icons/profesional_only_icon.svg` },
] as const;

const AppFooterAdvantages: React.FC = () => {
  const classes = useStyles();
  const t = useTranslate();

  return (
    <Container className={classes.root}>
      {advantageItems.map((advantage) => {
        const label = t(`appFooterAdvantages/${advantage.key}/label`);
        const description = t(`appFooterAdvantages/${advantage.key}/description`);
        return (
          <div key={advantage.key} className={classes.advantage}>
            <img className={classes.icon} src={advantage.src} alt={label} />
            <div className={classes.text}>
              <span className={classes.label}>{label}</span>
              <p>{description}</p>
            </div>
          </div>
        );
      })}
    </Container>
  );
};

AppFooterAdvantages.displayName = 'AppFooterAdvantages';

export default AppFooterAdvantages;
